// দোকানের আলাদা আলাদা ব্যবসায়িক লাইন — Purchase/Sales/Stock/Reports/Accounts
// সবখানে এই একই তালিকা ব্যবহার হয় যাতে সব জায়গায় সমান থাকে।
export const BUSINESS_TYPES = [
  'Saree',
  'Hand Stitched Dresses',
  'Panjabi',
  'Pakistani Dresses',
  'Kizuna Skincare',
  'Jewellery',
  'Bags'
];

// পুরনো সেল/পার্চেজ/রিটার্নে businessType 'Hand Made Jewellery' হিসেবে সেভ করা
// আছে (রিনেম করার আগের নাম) -- সেই পুরনো historical রেকর্ড না বদলিয়ে, পড়ার সময়
// এখানে নতুন নামে ম্যাপ করে দেওয়া হচ্ছে, যাতে Reports/Accounts-এ ঠিকভাবে যোগ হয়।
const LEGACY_BUSINESS_TYPE_MAP = { 'Hand Made Jewellery': 'Jewellery' };

// পুরনো প্রোডাক্ট/সেল যেগুলোতে businessType ফিল্ড নেই (এই ফিচার আসার আগে তৈরি),
// সেগুলো ডিফল্টভাবে 'Saree' ধরা হবে।
export const getBusinessType = (item) => {
  const raw = item?.businessType;
  return LEGACY_BUSINESS_TYPE_MAP[raw] || raw || 'Saree';
};
